import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AuthLayout from "../components/auth/AuthLayout";

const SignupPage = () => {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) { setError("Please agree to the terms & policy"); return; }
    setError("");
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      navigate("/community");
    } catch (err) {
      setError(err.error || err.details?.[0]?.message || "Registration failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <h1 className="text-[32px]  font-semibold text-gray-900 mb-4 font-body">Get Started Now</h1>
      {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-[13px] text-red-600">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-5">
          <label className="block text-[14px] font-medium text-gray-900 mb-1.5">Name</label>
          <input type="text" placeholder="Enter your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[12px] text-[#000000] placeholder-[#000000] outline-none focus:border-primary transition-colors font-body" />
        </div>
        <div className="mb-5">
          <label className="block text-[14px] font-medium text-gray-900 mb-1.5">Email address</label>
          <input type="email" placeholder="Enter your email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[12px] text-[#000000] placeholder-[#000000] outline-none focus:border-primary transition-colors font-body" />
        </div>
        <div className="mb-5">
          <label className="block text-[14px] font-medium text-gray-900 mb-1.5">Password</label>
          <input type="password" placeholder="Create a password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={6}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[12px] text-[#000000] placeholder-[#000000] outline-none focus:border-primary transition-colors font-body" />
        </div>
        <div className="flex items-center gap-2 mb-6">
          <input type="checkbox" id="terms" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} className="w-4 h-4 rounded border-[#000000]" />
          <label htmlFor="terms" className="text-[13px] font-medium text-[#000000] font-body">I agree to the <span className="underline font-medium cursor-pointer">terms & policy</span></label>
        </div>
        <button type="submit" disabled={loading}
          className="w-full py-3 bg-[#1F3A60] border border-[#1F3A60] text-white rounded-lg font-semibold text-[13px] Inter hover:bg-primary-dark transition-colors font-body disabled:opacity-60 mb-3">
          {loading ? "Creating account..." : "Signup"}
        </button>
      </form>

      {/* <div className="flex items-center gap-4 mb-6">
        <div className="flex-1 h-px bg-gray-200" /><span className="text-[13px] text-gray-400">Or</span><div className="flex-1 h-px bg-gray-200" />
      </div> */}

      <p className="text-center text-[14px] text-[#000000] font-body font-medium">
        Have an account?{" "}<Link to="/login" className="text-[#1F3A60] font-semibold hover:underline">Sign In</Link>
      </p>
    </AuthLayout>
  );
};

export default SignupPage;
